<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <!-- <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        그룹
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="dtgTeamId"
                (ngModelChange)="changeTeamInfo($event)">
                <option [ngValue]="''" *ngIf="userGroupId <= 100">전체그룹</option>
                <option [ngValue]="'undefined'">미설정</option>
                <option *ngFor="let item of listTeam;"
                    [ngValue]="item.dtgTeamId">
                    {{item.dtgTeamNm}}
                </option>
            </select>
        </div>
    </div> -->
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        사용여부
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="useYn"
                (ngModelChange)="changeUseYn($event)">
                <option [ngValue]="''">전체</option>
                <option [ngValue]="'Y'">Y</option>
                <option [ngValue]="'N'">N</option>
            </select>
        </div>
    </div>
    <div class="col"></div>
    <div class="col-auto"
        [hidden]="listType === DtgListType.modal">
        <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="clickOpenModalGeofenceInfo(DtgActionType.create,null)">
            <i class="mdi mdi-plus"></i>
            <span class="ml-1">
                설정추가
            </span>
        </button>
    </div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
            (click)="exportExcel()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">엑셀출력</span>
        </button>
    </div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="">
            <!-- <th>
                그룹이름
            </th> -->
            <th>
                설정이름
            </th>
            <th>
                설정형태
            </th>
            <!-- <th>
                운형형태
            </th>
            <th>
                알림(진입)
            </th>
            <th>
                알림(이탈)
            </th> -->
            <th>
                사용여부
            </th>
            <th [hidden]="listType === DtgListType.modal">
                편집
            </th>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listGeofence;">
                <!-- <td>
                    <span [hidden]="!item.dtgTeamNm">{{item.dtgTeamNm}}</span>
                    <span [hidden]="item.dtgTeamNm" class="text-warning">미설정</span>
                </td> -->
                <td>
                    <span>{{item.geoFenceNm}}</span>
                </td>
                <td [ngSwitch]="item.shapeType">
                    <span *ngSwitchCase="'C'">원형</span>
                    <span *ngSwitchCase="'R'">사각형</span>
                    <span *ngSwitchDefault>다각형</span>
                </td>
                <!-- <td [ngSwitch]="item.routeType">
                    <span *ngSwitchCase="'C'">차고지</span>
                    <span *ngSwitchCase="'P'">경유지</span>
                    <span *ngSwitchDefault>일반</span>
                </td>
                <td>
                    <span>{{item.notiYnIn}}</span>
                </td>
                <td>
                    <span>{{item.notiYnOut}}</span>
                </td> -->
                <td>
                    {{item.useYn}}
                </td>
                <td [hidden]="listType === DtgListType.modal">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="clickOpenModalGeofenceInfo(DtgActionType.update,item)">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">수정</span>
                    </button>
                    <!-- <button type="button" class="btn btn-sm btn-outline-secondary ml-2"
                        (click)="clickOpenModalGeofenceCarList(DtgActionType.update,item)">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">차량관리</span>
                    </button> -->
                    <!-- <button type="button" class="btn btn-sm btn-outline-secondary ml-2">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">알림사용자관리</span>
                    </button> -->
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>